import { render, staticRenderFns } from "./ContactNewsletter.vue?vue&type=template&id=0f6dc914&scoped=true&"
import script from "./ContactNewsletter.vue?vue&type=script&lang=js&"
export * from "./ContactNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./ContactNewsletter.vue?vue&type=style&index=0&id=0f6dc914&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6dc914",
  null
  
)

export default component.exports